import getUrlParameter from './getUrlParameter';
import capitalize from './capitalize';

const helpers = {
  getUrlParameter,
  capitalize
};

export default helpers;
